// extracted by mini-css-extract-plugin
export default {"select":"TasksPage_select__-+Edr"};